import type { Masker } from './mask-object-values'

export const maskKeys =
  (keys: string[]): Masker =>
  (key, value) => {
    const loweredKeys = keys.map((k) => k.toLowerCase())
    return loweredKeys.includes(key.toLowerCase()) ? 'MASKED' : value
  }
